import { render, staticRenderFns } from "./ConsumptionDataExchangeEADBergischesLand.vue?vue&type=template&id=cbbd42d6&lang=pug&"
import script from "./ConsumptionDataExchangeEADBergischesLand.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeEADBergischesLand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports